export default __webpack_public_path__ + "9ff858dea60883f42db94d98d556a879.jpg";